export default __webpack_public_path__ + "static/media/hr_info.5bb9cf80.svg";